import { Controller } from "@hotwired/stimulus"
import { hasMatch } from "fzy.js"
import { debounce, nextFrame } from "../helpers"

export default class extends Controller {
  static targets = ["filterable"]

  #query = ""

  initialize() {
    this.filter = debounce(this.filter.bind(this), 60)
  }

  filter(event) {
    this.#query = event.target.value
    this.update()
  }

  async update() {
    const match = (e) => hasMatch(this.#query, e.dataset.search)
    const state = this.filterableTargets.map((e) => [e, match(e)])
    await nextFrame()
    for (const [element, match] of state) element.hidden = !match
  }
}
